import type { Ride } from '../domain/ride';
import type { RideImportState } from '../hooks/use-ride-import';
import type { StudioDraft } from './studio-draft';
import { ComposingEditor } from './composing/ComposingEditor';

export function StudioWorkspace(props: {
  initialDraft?: StudioDraft | undefined; initialDraftSource?: 'file' | undefined; ride: Ride; importState: RideImportState;
  onRideSelected: (file: File) => void; onRenameRide: (title: string) => boolean;
}) {
  return <ComposingEditor {...props} />;
}
